export class PremioSorteioModel {

    public seqPremioSorteioPremiacaoConsumidor: number;
    public valPremio: number;
    
    public qtdPremio: number;
    
    public dataAtualizacao: Date;
}


// WEBPACK FOOTER //
// ./src/app/shared/model/premio-sorteio.model.ts